<template>
  <div class="form-group required" v-bind:class="{'has-error': hasErrors}">
    <label  v-if="hasLabel" class="control-label" v-bind:for="inputId" v-bind:class="{ 'required': obligatory }">
      <abbr title="required" v-if="obligatory">*</abbr>
      {{label}}
    </label>
    <textarea
      v-bind:id="inputId"
      :value="value"
      class="form-control required"
      v-bind:placeholder="placeholder">
    </textarea>
    <span v-if="hasErrors" class="help-block">{{message}}</span>
  </div>
</template>

<script>
export default {
  props:   {
    id: {
      type: String,
      required: false,
      default: null
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type:     String,
      required: false,
      default:  ""
    },
    placeholder: {
      type:     String,
      required: false,
      default:  ""
    },
    value: {
      type:     String,
      required: false
    },
    obligatory: {
      type:     Boolean,
      default:  false
    }
  },
  data() {
    return {
      inputId: ""
    }
  },
  mounted() {
    let vm = this,
      input = this.$el.querySelector("textarea");
    this.setId();
    input.onkeyup = function() {
      vm.$emit("input", this.value)
    }
  },
  watch: {
    value(value) { },
    errors(value){ }
  },
  computed: {
    hasErrors() {
      return this.errors != null && this.errors.hasOwnProperty(this.name)
    },
    message() {
      return (this.hasErrors) ? this.errors[this.name][0] : ""
    },
    hasLabel() {
      return (this.label.length > 0)
    }
  },
  methods: {
    setId() {
      if(this.id == null) {
        this.inputId = new Date().getTime().toString();
      } else {
        this.inputId = this.id;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
  textarea {
    resize: none;
  }
</style>
